// Module
var code = "<!DOCTYPE html> <div id=\"cop-header\"> <div class=\"position\"> <div class=\"welcome\">您好，{{name}}</div> </div> <div style=\"margin-top:80px;height:3px;width:100%;background-color:#d5d5d5\"></div> </div>";
// Exports
module.exports = code;